import useKeycloak from '../hooks/useKeycloak';
import { useUserInfoQuery } from '../api/userApiSlice';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const ProtectedRoute = ({ children, route }: any) => {
    useKeycloak();
    const { data: userData, error } = useUserInfoQuery({});

    const navigate = useNavigate();

    const hasAccess = (route: any): boolean => {
        const userRoles = userData?.roles || [];
        if (!route.requiredRoles) return true; // No roles required, allow access

        // Check if the user has any excluded role
        if (route.excludedRoles && route.excludedRoles.some((role: string) => userRoles.includes(role))) {
            return false; // Deny access if the user has any excluded role
        }
        if (route?.disabled){
            return false;
        }
        if (error) {
            // handle error in case access has been restricted for the user
            //@ts-ignore
            throw new Error(error.status);
        }

        // Check if the user has at least one of the required roles
        return route.requiredRoles.some((role: string) => userRoles.includes(role));
    };

    useEffect(() => {
        if(!hasAccess(route)) {
            navigate("/");
        }
    }, []);


    return (
        children
    )

}

export default ProtectedRoute;